import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { PureComponent, Children } from 'react';
import types from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { compose, mapProps, withState, withHandlers } from 'recompose';
import { StylesProvider, StyleSheet } from '@rexlabs/styling';
import { TextInput, defer } from '@rexlabs/text-input';
import DayPickerSingleDateController from './components/day-picker-single-date-controller';
import isInclusivelyAfterDay from './utils/isInclusivelyAfterDay';
var assign = _Object$assign;
var baseProps = {
  isOutsideRange: function isOutsideRange(day) {
    return !isInclusivelyAfterDay(day, moment());
  },
  hideKeyboardShortcutsPanel: true,
  numberOfMonths: 1
};
var positionsFrom = {
  top: 'bottom',
  bottom: 'top'
};

var getPosition = function getPosition(position) {
  return _defineProperty({
    position: 'absolute',
    left: 0
  }, positionsFrom[position], '100%');
};

var Calendar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Calendar, _PureComponent);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Calendar).call(this, props));
    var colorPrimary = props.colorPrimary,
        colorPrimaryLight = props.colorPrimaryLight,
        colorPrimaryDark = props.colorPrimaryDark;
    _this.calendarComponents = {
      CalendarDay: StyleSheet({
        afterHoveredStart: {
          backgroundColor: colorPrimaryLight,
          borderColor: colorPrimaryLight,
          ':active': {
            backgroundColor: colorPrimaryLight
          }
        },
        hoveredSpan: {
          backgroundColor: colorPrimaryLight,
          borderColor: colorPrimaryLight,
          ':active': {
            backgroundColor: colorPrimaryLight
          }
        },
        highlightedCalendar: {
          borderColor: colorPrimaryLight,
          ':active': {
            borderColor: colorPrimaryLight
          }
        },
        today: {
          borderColor: colorPrimaryDark
        },
        lastInRange: {
          borderRightColor: colorPrimaryLight
        },
        blockedMinimumNights: {
          backgroundColor: colorPrimaryLight,
          borderColor: colorPrimaryLight,
          ':active': {
            backgroundColor: colorPrimaryLight
          }
        },
        selectedSpan: {
          backgroundColor: colorPrimary,
          borderColor: colorPrimary,
          ':active': {
            backgroundColor: colorPrimaryLight
          }
        },
        selected: {
          backgroundColor: colorPrimaryDark,
          borderColor: colorPrimaryDark,
          ':active': {
            backgroundColor: colorPrimaryDark
          }
        },
        selectedStart: {
          backgroundColor: colorPrimaryDark,
          borderColor: colorPrimaryDark,
          ':active': {
            backgroundColor: colorPrimaryDark
          }
        },
        selectedEnd: {
          backgroundColor: colorPrimaryDark,
          borderColor: colorPrimaryDark,
          ':active': {
            backgroundColor: colorPrimaryDark
          }
        }
      }),
      DayPickerKeyboardShortcuts: StyleSheet({
        topLeft: {
          borderLeftColor: colorPrimary,
          ':hover': {
            borderLeftColor: colorPrimaryDark
          }
        },
        topRight: {
          borderRightColor: colorPrimary,
          ':hover': {
            borderRightColor: colorPrimaryDark
          }
        },
        bottomRight: {
          borderRightColor: colorPrimary,
          ':hover': {
            borderRightColor: colorPrimaryDark
          }
        }
      }),
      DayPickerNavigation: StyleSheet({
        prev: {
          ':focus': {
            borderColor: colorPrimary,
            boxShadow: "0 0 5px ".concat(colorPrimary)
          },
          ':active': {
            borderColor: colorPrimary,
            boxShadow: "0 0 5px ".concat(colorPrimary)
          }
        },
        next: {
          ':focus': {
            borderColor: colorPrimary,
            boxShadow: "0 0 5px ".concat(colorPrimary)
          },
          ':active': {
            borderColor: colorPrimary,
            boxShadow: "0 0 5px ".concat(colorPrimary)
          }
        }
      })
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colorPrimary = _this$props.colorPrimary,
          colorPrimaryLight = _this$props.colorPrimaryLight,
          colorPrimaryDark = _this$props.colorPrimaryDark,
          _this$props$position = _this$props.position,
          position = _this$props$position === void 0 ? 'bottom' : _this$props$position,
          props = _objectWithoutProperties(_this$props, ["colorPrimary", "colorPrimaryLight", "colorPrimaryDark", "position"]);

      return React.createElement(StylesProvider, {
        key: 'calendar',
        components: this.calendarComponents
      }, React.createElement("div", {
        style: getPosition(position)
      }, React.createElement(DayPickerSingleDateController, _extends({}, baseProps, props))));
    }
  }]);

  return Calendar;
}(PureComponent);

var withCalendar = compose(withState('focused', 'onFocusChange', false), withHandlers({
  onFocus: function onFocus(_ref2) {
    var _ref2$onFocus = _ref2.onFocus,
        _onFocus = _ref2$onFocus === void 0 ? _.noop : _ref2$onFocus,
        onFocusChange = _ref2.onFocusChange;

    return function (e) {
      onFocusChange(true);

      _onFocus(e);
    };
  },
  onDateChange: function onDateChange(_ref3) {
    var _ref3$onChange = _ref3.onChange,
        onChange = _ref3$onChange === void 0 ? _.noop : _ref3$onChange;
    return function (date) {
      onChange({
        target: {
          value: date
        }
      });
    };
  },
  onOutsideClick: function onOutsideClick(_ref4) {
    var _ref4$onBlur = _ref4.onBlur,
        onBlur = _ref4$onBlur === void 0 ? _.noop : _ref4$onBlur,
        onFocusChange = _ref4.onFocusChange,
        focused = _ref4.focused;
    return function (e) {
      onFocusChange(false);
      onBlur(e);
    };
  }
}), mapProps(function (_ref5) {
  var daySize = _ref5.daySize,
      colorPrimary = _ref5.colorPrimary,
      colorPrimaryLight = _ref5.colorPrimaryLight,
      colorPrimaryDark = _ref5.colorPrimaryDark,
      colorText = _ref5.colorText,
      position = _ref5.position,
      navPrev = _ref5.navPrev,
      navNext = _ref5.navNext,
      keyboardShortcutsCloseButton = _ref5.keyboardShortcutsCloseButton,
      focused = _ref5.focused,
      onChange = _ref5.onChange,
      onFocusChange = _ref5.onFocusChange,
      onDateChange = _ref5.onDateChange,
      onOutsideClick = _ref5.onOutsideClick,
      isOutsideRange = _ref5.isOutsideRange,
      value = _ref5.value,
      children = _ref5.children,
      enableOutsideDays = _ref5.enableOutsideDays,
      weekDayFormat = _ref5.weekDayFormat,
      renderWeekDay = _ref5.renderWeekDay,
      padding = _ref5.padding,
      monthPadding = _ref5.monthPadding,
      paddingBottom = _ref5.paddingBottom,
      _ref5$displayFormat = _ref5.displayFormat,
      displayFormat = _ref5$displayFormat === void 0 ? 'Do MMMM YYYY' : _ref5$displayFormat,
      props = _objectWithoutProperties(_ref5, ["daySize", "colorPrimary", "colorPrimaryLight", "colorPrimaryDark", "colorText", "position", "navPrev", "navNext", "keyboardShortcutsCloseButton", "focused", "onChange", "onFocusChange", "onDateChange", "onOutsideClick", "isOutsideRange", "value", "children", "enableOutsideDays", "weekDayFormat", "renderWeekDay", "padding", "monthPadding", "paddingBottom", "displayFormat"]);

  return _objectSpread({}, props, {
    type: 'text',
    value: moment.isMoment(value) ? displayFormat ? _.isFunction(displayFormat) ? displayFormat(value) : value.format(displayFormat) : value : '',
    onChange: function onChange() {
      onDateChange('');
    },
    children: !focused ? children : [React.createElement(Calendar, {
      key: "calendar",
      date: moment.isMoment(value) ? value : undefined,
      daySize: daySize,
      colorPrimary: colorPrimary,
      colorPrimaryLight: colorPrimaryLight,
      colorPrimaryDark: colorPrimaryDark,
      colorText: colorText,
      position: position,
      navPrev: navPrev,
      navNext: navNext,
      keyboardShortcutsCloseButton: keyboardShortcutsCloseButton,
      focused: focused,
      onFocusChange: onFocusChange,
      onDateChange: onDateChange,
      onOutsideClick: onOutsideClick,
      isOutsideRange: isOutsideRange,
      enableOutsideDays: enableOutsideDays,
      weekDayFormat: weekDayFormat,
      renderWeekDay: renderWeekDay,
      padding: padding,
      monthPadding: monthPadding,
      paddingBottom: paddingBottom
    })].concat(_toConsumableArray(Children.toArray(children)))
  });
}));
withCalendar.displayName = 'withCalendar';
var propTypes = {
  colorPrimary: types.string,
  colorPrimaryLight: types.string,
  colorPrimaryDark: types.string,
  navPrev: types.node,
  navNext: types.node,
  keyboardShortcutsCloseButton: types.node,
  isOutsideRange: types.func
};
var defaultProps = {
  colorPrimary: 'turquoise',
  colorPrimaryLight: 'paleturquoise',
  colorPrimaryDark: 'darkturquoise',
  navPrev: React.createElement("span", null, "Prev"),
  navNext: React.createElement("span", null, "Next"),
  keyboardShortcutsCloseButton: React.createElement("span", null, "X")
};
export default assign(defer(withCalendar)(TextInput), {
  displayName: 'DateInput',
  propTypes: _objectSpread({}, TextInput.propTypes, {}, propTypes, {
    value: types.oneOfType([propTypes.string, propTypes.object])
  }),
  defaultProps: _objectSpread({}, TextInput.defaultProps, {}, defaultProps)
});